/** What the sync pill and Sync Center say, derived from engine + session state. */
import type { SessionStatus } from '@/lib/auth/session';

import type { SyncSnapshot } from './engine';

export type SyncIndicator =
  | { kind: 'syncing' }
  | { kind: 'offline'; pending: number }
  | { kind: 'signin'; pending: number }
  | { kind: 'error'; attention: number }
  | { kind: 'pending'; pending: number }
  | { kind: 'unsynced' }
  | { kind: 'synced'; at: string };

export function deriveIndicator(sync: SyncSnapshot, session: SessionStatus): SyncIndicator {
  const pending = sync.counts.pending + sync.counts.in_flight + sync.counts.failed;
  const attention = sync.counts.conflict + sync.counts.rejected;
  if (sync.running) return { kind: 'syncing' };
  if (sync.authRequired || session === 'reauth_required') return { kind: 'signin', pending };
  if (sync.connectivity === 'offline' || session === 'offline') return { kind: 'offline', pending };
  if (attention > 0 || sync.counts.failed > 0 || sync.lastError) {
    return { kind: 'error', attention: attention + sync.counts.failed };
  }
  if (pending > 0) return { kind: 'pending', pending };
  // An empty outbox is not "synced" until a sync has completed: a device whose
  // first sync has not finished (or was cut short by a reload) has not got the
  // project's records yet, and must not say it is ready to go offline.
  if (sync.lastSuccessAt === null) return { kind: 'unsynced' };
  return { kind: 'synced', at: sync.lastSuccessAt };
}
